import { createSelector } from '@reduxjs/toolkit';

import { mapPublicExchangesToObj } from './exchange-item';
import type { ExchangeObjItems } from './exchange-item';
import { exchangesApi, exchangesApiEndpoints } from './exchanges-api';
import type { ExchangeScope } from './types';

export interface ExchangesApiStore {
  exchangesApi: ReturnType<typeof exchangesApi.reducer>;
}

const makeSelectListExchange = (scope: ExchangeScope) => {
  const selectPublicExchanges = exchangesApiEndpoints.listPublicExchanges.select({ scope });

  return createSelector(
    (state: ExchangesApiStore) => selectPublicExchanges(state).data,
    (data): ExchangeObjItems => mapPublicExchangesToObj(data, scope),
  );
};

const selectListExchangeByScope = {
  mm: makeSelectListExchange('mm'),
  es: makeSelectListExchange('es'),
};

/**
 * The caller-scoped exchange list in the {@link ExchangeObjItems} shape, read
 * straight from the RTK Query cache: a page keeps it populated by subscribing
 * with `useListPublicExchanges({ scope })`. Returns one memoized selector per
 * scope.
 */
export const selectListExchange = (scope: ExchangeScope) => selectListExchangeByScope[scope];
